import { Chat, ContactDetails } from '../Pages/Chats/chat.types';
import { USER_ADMIN_CHAT } from './contants';

const ORDER_ENTITY_TYPE_MAP: Record<string, string> = {
  production: 'productions',
  episode: 'episodes',
  set: 'sets',
  location: 'locations',
  department: 'departments',
  booking: 'bookings',
  studio: 'studios',
};

/**
 * Maps a (possibly singular/legacy) entity type value to the plural form
 * expected by the order list API (endPoints.order.orderList).
 */
export const normalizeOrderEntityType = (entityType?: string): string => {
  if (!entityType) return entityType as string;
  return ORDER_ENTITY_TYPE_MAP[entityType] || entityType;
};

export function calculateFileSize(file: File): string {
  const bytes = file.size;

  if (bytes === 0) {
    return '0 Bytes';
  }

  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));

  if (i === 0) {
    return `${bytes} ${sizes[i]}`;
  }

  return `${(bytes / Math.pow(1024, i)).toFixed(2)} ${sizes[i]}`;
}
export const convertLinkString = (input: string) => {
  const urlRegex =
    /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g;
  const matches = input.match(urlRegex);
  let output = input;
  if (!matches) {
    return input;
  }
  for (const match of matches) {
    const protocolRegex = /^(?:https?|ftp):\/\//.test(match);
    output = output.replace(
      match,
      `<a href="${
        !protocolRegex && 'https://'
      }${match}" target="_new" rel="noopener noreferrer">${match}</a>`,
    );
  }
  return output;
};

export const chatConvertLinkString = (input: string) => {
  input = input.trim();
  const urlRegex =
    /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%.\+#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%\+.#?&//=]*)/g;
  const matches = input.match(urlRegex);
  // Replace spaces with non-breaking spaces and newlines with <br>:
  let output = input.replace(/ /g, ' ').replace(/\n/g, '<br>');

  if (!matches) {
    return output;
  }
  for (const match of matches) {
    const protocolRegex = /^(?:https?|ftp):\/\//.test(match);
    const href = protocolRegex ? match : `https://${match}`;
    output = output.replace(
      match,
      `<a href="${href}" target="_new" rel="noopener noreferrer">${match}</a>`,
    );
  }
  return output;
};
export class ChatBuilder {
  private chat: Chat;
  constructor(chatId: string) {
    this.chat = {
      _id: chatId,
      members: [],
      type: 'ONE_TO_ONE',
      businessChatType: USER_ADMIN_CHAT,
      lastMessageDetail: {},
      lastMsgCreated: new Date().getTime(),
      contactDetails: {},
      noOfUnreadMessage: 0,
      userOnlineStatus: null,
      isNewChat: true,
    };
  }
  setBusinessChatType(chatType: string) {
    this.chat.businessChatType = chatType;
    return this;
  }
  setContactDetails(contactDetails: ContactDetails) {
    this.chat.contactDetails = contactDetails;
    return this;
  }
  addMembers(memberId: string) {
    this.chat.members?.push(memberId);
    return this;
  }
  getChat() {
    return this.chat;
  }
}

export const createChat = ({
  chatId,
  businessChatType,
  senderId,
  receiverId,
  contactDetails,
}: {
  chatId: string;
  senderId: string;
  receiverId: string;
  contactDetails: ContactDetails;
  businessChatType: string;
}) => {
  const newChat: Chat = new ChatBuilder(chatId)
    .addMembers(senderId)
    .addMembers(receiverId)
    .setBusinessChatType(businessChatType)
    .setContactDetails(contactDetails)
    .getChat();
  return {
    newChat,
  };
};

/** CHAT_FORMATION / createChat API — maps top-level `isOnline` & `lastSeen` for ThreadCard / ChatHeader. */
export function userOnlineStatusFromFormationResponse(
  data: Record<string, any> | undefined | null,
  contactId: string,
): { isOnline: boolean; lastSeen: number | string | null; contactId: string } {
  const d = data && typeof data === 'object' ? data : {};
  const online =
    d.isOnline === true || d.isOnline === 'true' || d.online === true;
  return {
    isOnline: !!online,
    lastSeen: d.lastSeen != null && d.lastSeen !== '' ? d.lastSeen : null,
    contactId,
  };
}
